import ClassicEditor from "../../ckeditor";
import Utils from "../../utils/Utils";
import Alert from "../../utils/messages";

export default {

    init() {

        function parseResponseError(error) {

            if (error.response) {

                const status = error.response.status;

                if (status === 422) {
                    return Alert.buildMessageList(Alert.parseValidationExceptionResponse(error.response));
                } else {
                    return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
                }
            } else {
                return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
            }
        }

        const QUIETANZA = "quietanza";
        const MANDATO = "mandato";
        const PREZZO_CONCORDATO = "prezzo_concordato";

        const TABLE_PRODUCTS_SINGLE = "#table-products-singolo";
        const TABLE_PRODUCTS_SINGLE_BODY = "#table-products-singolo > tbody";
        const TABLE_PRODUCTS_COLLECTION = "#table-products-collezione";
        const TABLE_PRODUCTS_COLLECTION_BODY = "#table-products-collezione > tbody";

        const TABLE_PRODUCTS_ROW_ACCOUNTING_SINGLE = "#table-products-row-accounting-single";
        const TABLE_PRODUCTS_ROW_ACCOUNTING_COLLECTION = "#table-products-row-accounting-collection";

        const INPUT_SELECT_ALL = ".input-select-all-products";

        const INPUT_SELECT_PRODUCT = ".input-select-product";

        const MODAL_CREATE_EDIT_PRODUCT = "#modal-ce-product";
        const MODAL_CREATE_EDIT_PRODUCT_TITLE = "#modal-ce-product-title";

        const MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE = "#modal-ce-product-input-type";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE = "#modal-ce-product-input-code";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS = "#modal-ce-product-input-symbols";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_DESCRIPTION = "#modal-ce-product-input-description";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG = "#modal-ce-product-input-catalog";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COST = "#modal-ce-product-input-cost";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION = "#modal-ce-product-input-commission";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE = "#modal-ce-product-input-selling-price";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE = "#modal-ce-product-input-agreed-price";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_DESCRIPTION = "#modal-ce-product-input-catalog-description";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES = "#modal-ce-product-input-notes";
        const MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT = "#modal-ce-product-btn-submit";

        const MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER = "#modal-ce-product-col-input-catalog-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER = "#modal-ce-product-col-input-commission-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER = "#modal-ce-product-col-input-cost-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER = "#modal-ce-product-col-input-selling-price-wrapper";
        const MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER = "#modal-ce-product-col-input-agreed-price-wrapper";

        const ROW_ERRORS = "#modal-ce-product #row-errors";
        const LIST_ERRORS = "#modal-ce-product #list-errors";

        const BTN_EDIT_PRODUCT = ".btn-edit-product";

        const DATA_PRODUCT_ID = "product-id";

        const BTN_CREATE_PRODUCT = "#btn-create-product";

        const BTN_DELETE_PRODUCT = ".btn-delete-product";

        const BTN_DELETE_ALL_PRODUCTS = "#btn-delete-all-products";

        const SINGOLO = "singolo";
        const COLLEZZIONE = "collezione";

        let _purchasing_channel = null;

        let _editors = [];

        function setupWysiwyg() {

            for (const editor of _editors) {
                editor.destroy();
            }

            _editors = [];

            const elements = document.querySelectorAll(".wysiwyg");

            for (const element of elements) {
                ClassicEditor.create(element).then(editor => {
                    editor.editing.view.change(writer => {
                        writer.setStyle('height', '100px', editor.editing.view.document.getRoot());
                    });
                    //_editors.push(editor);
                    _editors.push({
                        id: element.id,
                        editor: editor,
                    })
                });
            }
        }

        function updateWysiwygSource() {

            for (const editor of _editors) {
                editor['editor'].updateSourceElement();
            }
        }

        function updateWysiwygData(id, data) {
            for (const editor of _editors) {
                if (editor.id === id) {
                    const wysiwyg = editor.editor;
                    wysiwyg.setData(data);
                    wysiwyg.updateSourceElement();
                }
            }
        }

        function getCurrentSelectedTab() {

            const nav_link = $("a.nav-link.active");

            const href = $(nav_link).attr('href');

            if (href === "#products-collezione") {
                return COLLEZZIONE;
            } else {
                return SINGOLO;
            }
        }

        function clearModalCreateEditProduct() {

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val($(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE} option:first`).val()).change();
            //CODE WILL BE CHANGED AUTOMATICALLY
            //$(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val('');
            //$(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).prop('checked', false);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val('');
            updateWysiwygData('modal-ce-product-input-description', '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(0/*_purchasing_channel.amount*/);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(_purchasing_channel.commission);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(0);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(0);
            updateWysiwygData('modal-ce-product-input-catalog-description', '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val('');
            $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).data(DATA_PRODUCT_ID, "");

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).addClass('d-none');

            switch (_purchasing_channel.type) {
                case QUIETANZA:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    break;
                case MANDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).removeClass('d-none');
                    break;
                case PREZZO_CONCORDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).removeClass('d-none');
                    break;
            }

            $(LIST_ERRORS).html('');
            $(ROW_ERRORS).hide();
        }

        function fillModalCreateEditProduct(product) {
            clearModalCreateEditProduct();

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val(product.type).change();
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(product.code);
            /*$(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).prop('checked', false);

            for (const symbol of product.symbols) {
                $(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS}[value=${symbol}]`).prop('checked', true);
            }*/

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val(product.symbols.join(','));

            updateWysiwygData('modal-ce-product-input-description', product.description ?? '');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(product.catalog);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(product.cost);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(product.commission);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(product.selling_price);
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(product.agreed_price);
            updateWysiwygData('modal-ce-product-input-catalog-description', product.catalog_description ?? '');

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val(product.notes);
            $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).data(DATA_PRODUCT_ID, product.id);

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).addClass('d-none');
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).addClass('d-none');

            switch (product.purchasing_channel_type) {
                case QUIETANZA:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    break;
                case MANDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE_WRAPPER).removeClass('d-none');
                    break;
                case PREZZO_CONCORDATO:
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST_WRAPPER).removeClass('d-none');
                    $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE_WRAPPER).removeClass('d-none');
                    break;
            }

        }

        function getModalCreateEditProductData() {
            updateWysiwygSource();

            /*const symbols = [];

            $(`${MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS}:checked`).each(function (index, symbol) {
                symbols.push($(symbol).val());
            });*/

            const symbols = $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SYMBOLS).val().split(',');

            console.log(symbols);

            const data = {
                type: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val(),
                code: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(),
                symbols: symbols,
                description: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_DESCRIPTION).val(),
                catalog: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG).val(),
                cost: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COST).val(),
                commission: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_COMMISSION).val(),
                selling_price: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_SELLING_PRICE).val(),
                agreed_price: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_AGREED_PRICE).val(),
                catalog_description: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CATALOG_DESCRIPTION).val(),
                notes: $(MODAL_CREATE_EDIT_PRODUCT_INPUT_NOTES).val(),
            }

            return data;
        }

        function storeProduct(data, callback) {
            data['purchasing_channel_id'] = _purchasing_channel.id;
            data['purchasing_channel_type'] = _purchasing_channel.type;

            console.log(data);

            httpRequest.post(`admin/content/api/products`, data)
                .then(response => {

                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                })
                .catch(error => {
                    $(LIST_ERRORS).html(parseResponseError(error));
                    $(ROW_ERRORS).show();
                });
        }

        function updateProduct(product_id, data, callback) {

            httpRequest.put(`admin/content/api/products/${product_id}`, data)
                .then(response => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                })
                .catch(error => {
                    $(LIST_ERRORS).html(parseResponseError(error));
                    $(ROW_ERRORS).show();
                });
        }

        function showModalCreateEditProduct() {
            clearModalCreateEditProduct();
            getCurrentSelectedTab();
            $(MODAL_CREATE_EDIT_PRODUCT).modal('show');
        }

        function hideModalCreateEditProduct() {
            clearModalCreateEditProduct();
            $(MODAL_CREATE_EDIT_PRODUCT).modal('hide');
        }

        function productsTableRendered(html, type) {

            switch (type) {
                case SINGOLO:
                    $(TABLE_PRODUCTS_SINGLE_BODY).html(html);
                    break;
                case COLLEZZIONE:
                    $(TABLE_PRODUCTS_COLLECTION_BODY).html(html);
                    break;
            }
            const count_single = $(`${TABLE_PRODUCTS_SINGLE_BODY} tr.product-row`).length;
            const count_collection = $(`${TABLE_PRODUCTS_COLLECTION} tr.product-row`).length;
            $("#single-total").text(count_single);
            $("#collection-total").text(count_collection);
            $("#count-total").text(count_single + count_collection);
        }

        function renderProductsTable(purchasing_channel_id, type) {

            httpRequest.get(`admin/content/api/purchasing-channels/render-products-table/${purchasing_channel_id}/${type}`)
                .then(response => productsTableRendered(response.data.data, type))
                .catch(error => {
                });
        }

        function purchasingChannelLoaded(purchasing_channel, render_tables) {
            _purchasing_channel = purchasing_channel;

            if (render_tables) {
                renderProductsTable(_purchasing_channel.id, SINGOLO);
                renderProductsTable(_purchasing_channel.id, COLLEZZIONE);
            }

            loadAccountingForTable(_purchasing_channel.id, SINGOLO);
            loadAccountingForTable(_purchasing_channel.id, COLLEZZIONE);

            $(BTN_CREATE_PRODUCT).attr('disabled', false);

        }

        function loadPurchasingChannel(purchasing_channel_id, render_tables = true) {

            httpRequest.get(`admin/content/api/purchasing-channels/${purchasing_channel_id}`)
                .then(response => purchasingChannelLoaded(response.data.data, render_tables))
                .catch(error => {
                });
        }

        // all'apertura le tabelle arrivano già pronte dal server: non vanno richieste di nuovo
        loadPurchasingChannel(PURCHASING_CHANNEL_ID, false);

        function productLoaded(product, callback) {

            if (callback && typeof callback === "function") {
                callback(product);
            }
        }

        function loadProduct(product_id, callback) {

            httpRequest.get(`admin/content/api/products/${product_id}`)
                .then(response => productLoaded(response.data.data, callback))
                .catch(error => {
                });
        }

        $(BTN_CREATE_PRODUCT).click(function (e) {
            e.preventDefault();

            showModalCreateEditProduct();
            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).val(getCurrentSelectedTab()).change();

            $(MODAL_CREATE_EDIT_PRODUCT_TITLE).text("Nuovo articolo");
        });

        function inputProductTypeChanged(protocol_number, type) {

            let code = protocol_number;

            if (type === SINGOLO) {
                code = code + "/s"
            } else if (type === COLLEZZIONE) {
                code = code + "/"
            }

            $(MODAL_CREATE_EDIT_PRODUCT_INPUT_CODE).val(code);
        }

        $(MODAL_CREATE_EDIT_PRODUCT_INPUT_TYPE).change(function (e) {
            inputProductTypeChanged(_purchasing_channel.protocol_number, $(this).val());
        });

        $(MODAL_CREATE_EDIT_PRODUCT_BTN_SUBMIT).click(function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            const data = getModalCreateEditProductData();

            if (Utils.isEmpty(product_id)) {
                storeProduct(data, function () {
                    renderProductsTable(_purchasing_channel.id, data['type']);
                    loadAccountingForTable(_purchasing_channel.id, data['type']);
                    //PER L'INSERIMENTO NON CHIUDERE IL MODAL DOPO IL SALVATAGGI MA PULISCILO E BASTA
                    clearModalCreateEditProduct();

                    $('.nav-link').removeClass('active');
                    $('.tab-pane').removeClass('active');

                    if (data.type === SINGOLO) {
                        $('#nav-link-products-singolo').addClass('active');
                        $('#products-singolo').addClass('active');
                    } else {
                        $('#nav-link-products-collezione').addClass('active');
                        $('#products-collezione').addClass('active');
                    }
                    //hideModalCreateEditProduct();
                });
            } else {
                updateProduct(product_id, data, function () {
                    renderProductsTable(_purchasing_channel.id, data['type']);
                    loadAccountingForTable(_purchasing_channel.id, data['type']);
                    hideModalCreateEditProduct();
                });
            }

        });

        $(TABLE_PRODUCTS_SINGLE_BODY).on('click', BTN_EDIT_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            loadProduct(product_id, function (product) {
                showModalCreateEditProduct();
                fillModalCreateEditProduct(product);
                $(MODAL_CREATE_EDIT_PRODUCT_TITLE).text("Modifica articolo");
            });
        });

        $(TABLE_PRODUCTS_COLLECTION_BODY).on('click', BTN_EDIT_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            loadProduct(product_id, function (product) {

                showModalCreateEditProduct();
                fillModalCreateEditProduct(product);
                $(MODAL_CREATE_EDIT_PRODUCT_TITLE).text("Modifica articolo");

            });
        });

        $(TABLE_PRODUCTS_SINGLE).on('change', INPUT_SELECT_ALL, function (e) {

            const checked = $(this).is(':checked');

            if (checked) {
                $(`${TABLE_PRODUCTS_SINGLE_BODY} ${INPUT_SELECT_PRODUCT}`).attr('checked', true);
            } else {
                $(`${TABLE_PRODUCTS_SINGLE_BODY} ${INPUT_SELECT_PRODUCT}`).attr('checked', false);
            }
        });

        $(TABLE_PRODUCTS_COLLECTION).on('change', INPUT_SELECT_ALL, function (e) {

            const checked = $(this).is(':checked');

            if (checked) {
                $(`${TABLE_PRODUCTS_COLLECTION} ${INPUT_SELECT_PRODUCT}`).attr('checked', true);
            } else {
                $(`${TABLE_PRODUCTS_COLLECTION} ${INPUT_SELECT_PRODUCT}`).attr('checked', false);
            }
        });

        function productsDeleted() {
            loadPurchasingChannel(PURCHASING_CHANNEL_ID);
        }

        function deleteProducts(products) {

            const data = {
                products: products,
            }

            httpRequest.post(`admin/content/api/products/delete-products`, data)
                .then(response => productsDeleted())
                .catch(error => "");
        }

        $(BTN_DELETE_ALL_PRODUCTS).click(function (e) {
            e.preventDefault();

            const products = [];

            $(`${TABLE_PRODUCTS_SINGLE} ${INPUT_SELECT_PRODUCT}:checked`).each(function (index, item) {
                products.push($(item).val());
            });

            $(`${TABLE_PRODUCTS_COLLECTION} ${INPUT_SELECT_PRODUCT}:checked`).each(function (index, item) {
                products.push($(item).val());
            });

            if (products.length > 0 && confirm("Vuoi veramente eliminare gli articoli selezionati?")) {
                deleteProducts(products);
            }

        });

        $(TABLE_PRODUCTS_SINGLE_BODY).on('click', BTN_DELETE_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) > 0 && confirm("Vuoi veramente eliminare l'articolo selezionato?")) {
                deleteProducts([product_id]);
            }
        });

        $(TABLE_PRODUCTS_COLLECTION_BODY).on('click', BTN_DELETE_PRODUCT, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            if (!Utils.isEmpty(product_id) > 0 && confirm("Vuoi veramente eliminare l'articolo selezionato?")) {
                deleteProducts([product_id]);
            }
        });

        function accountingForTableLoaded(accounting, type) {
            switch (type) {
                case SINGOLO:
                    $(TABLE_PRODUCTS_ROW_ACCOUNTING_SINGLE).html(accounting);
                    break;
                case COLLEZZIONE:
                    $(TABLE_PRODUCTS_ROW_ACCOUNTING_COLLECTION).html(accounting);
                    break;
            }
        }

        function loadAccountingForTable(purchasing_channel_id, type) {

            const params = {
                type: type,
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/purchasing-channels/${purchasing_channel_id}/accounting-for-table`, {
                params: params
            }).then(response => accountingForTableLoaded(response.data.data, type))
                .catch(error => {
                });
        }

        setupWysiwyg();
    },

    finalize() {

    },
}
